import { useRef, useMemo, useState, useCallback } from 'react';
import { Button } from 'antd';
import DataTable from '../../components/DataTable';

import request from '@/request';

export default function PlayerExit({ event }) {
  const dataTableRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const tabs = [
    {
      label: '退赛申请',
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      ),
      api: '/events/dropOut/list',
      showAction: true,
      columns: [
        {
          title: '申请人',
          dataIndex: 'applyUserName',
          key: 'applyUserName',
        },
        { title: '用户身份', dataIndex: 'roleTypeText', key: 'roleTypeText' },
        { title: '退赛人', dataIndex: 'userName', key: 'userName' },
        { title: '选手编号', dataIndex: 'userId', key: 'userId' },
        {
          title: '退赛赛项',
          key: 'itemNames',
          render: (_, record) => (
            <span className="truncate block">
              {record.items.map((r) => r.itemName).join(',')}
            </span>
          ),
        },
        {
          title: '申请退赛金额（元）',
          dataIndex: 'refundAmount',
          key: 'refundAmount',
        },
        { title: '联系电话', dataIndex: 'userPhone', key: 'userPhone' },
        { title: '申请退赛原因', dataIndex: 'reason', key: 'reason' },
        {
          title: '操作',
          key: 'action',
          align: 'right',
          render: (_, record) => {
            // status: 0 待审核，1 已通过，2 已退赛，3 已拒绝
            if (record.status === 3) return null;
            if (record.status === 0) {
              return (
                <div className="flex items-center gap-2 justify-end">
                  <Button
                    type="text"
                    size="small"
                    className="text-blue-600 hover:text-blue-700"
                    onClick={() => handleApprove(record)}
                  >
                    批准
                  </Button>
                </div>
              );
            }
            if (record.status === 1) {
              return <span className="text-green-600">已批准</span>;
            }
            if (record.status === 2) {
              return <span className="text-slate-500">已退赛</span>;
            }
            return null;
          }
          // render: (_, record) => (
          //   <div className="flex items-center gap-2 justify-end">
          //     <Button
          //       type="text"
          //       size="small"
          //       className="text-blue-600 hover:text-blue-700"
          //       onClick={() => handleApprove(record)}
          //     >
          //       批准
          //     </Button>
          //   </div>
          // ),
        },
      ],
    },
    {
      label: '已退赛',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      ),
      api: '/events/dropOut/list',
      showAction: false,
      columns: [
        {
          title: '申请人',
          dataIndex: 'applyUserName',
          key: 'applyUserName',
          render: (t) => <span className="truncate block">{t}</span>,
          fixed: 'left',
          ellipsis: true,
        },
        { title: '用户身份', dataIndex: 'roleTypeText', key: 'roleTypeText' },
        { title: '退赛人', dataIndex: 'userName', key: 'userName' },
        { title: '选手编号', dataIndex: 'userId', key: 'userId' },
        {
          title: '退赛赛项',
          key: 'itemNames',
          render: (_, record) => (
            <span className="truncate block">
              {record.items.map((r) => r.itemName).join(',')}
            </span>
          ),
        },
        {
          title: '申请退赛金额（元）',
          dataIndex: 'totalAmount',
          key: 'totalAmount',
        },
        { title: '联系电话', dataIndex: 'userPhone', key: 'userPhone' },
        { title: '申请退赛原因', dataIndex: 'reason', key: 'reason' },
      ],
    },
  ];

  const handleApprove = useCallback(async (record) => {
    // TODO: 处理同意退赛逻辑
    console.log('同意退赛', record);
    // request.put('/events/dropOut/agree/' + record.id);
    try {
      await request.put('/events/dropOut/agree/' + record.id);
      dataTableRef.current?.refresh();
    } catch (err) {
      console.error('批准失败', err);
    }
  }, []);

  const options = useMemo(() => {
    const data = [
      { value: 'applyUserName', label: '申请人' },
      { value: 'userName', label: '退赛人' },
      { value: 'userId', label: '选手编号' },
    ];
    return data;
  }, []);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4 max-w-xl">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className={`flex items-center justify-center gap-2 py-3 px-4 rounded-lg text-center text-sm font-medium transition transform border cursor-pointer ${activeIndex === index
              ? 'bg-blue-50 border-blue-200 text-blue-700 shadow-sm'
              : 'bg-white border-slate-200 text-slate-600 hover:shadow hover:-translate-y-0.5'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              aria-hidden="true"
            >
              {tab.icon}
            </svg>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      <DataTable
        ref={dataTableRef}
        options={options}
        columns={tabs[activeIndex].columns}
        api={`${tabs[activeIndex].api}?eventId=${event.id}${activeIndex === 1 ? '&status=2' : ''}`}
      />
    </div>
  );
}
